import * as yup from 'yup'

import { FormFields } from './types'

export const validationSchema = yup.object().shape({
  [FormFields.appNameSetting]: yup.string().required().oneOf(['default', 'custom']),
  [FormFields.appName]: yup
    .string()
    .when(FormFields.appNameSetting, (appNameSetting: string) =>
      appNameSetting === 'custom' ? yup.string().required().max(30) : yup.string().max(30),
    ),
})
